import {
  anEntityInterface,
  anInsight,
  aSearchResult,
  aSearchResultPage,
  aSignal,
  mockAdvancedSearchQueryOperationQuery,
} from '__generated__';

export const handlers = [
  mockAdvancedSearchQueryOperationQuery((req, res, ctx) => {
    const resultType = req.variables.resultType;

    const results =
      resultType === 'INSIGHTS'
        ? aSearchResultPage({
            objects: [
              aSearchResult({
                object: anInsight(),
              }),
            ],
          })
        : resultType === 'SIGNALS'
        ? aSearchResultPage({
            objects: [
              aSearchResult({
                object: aSignal(),
              }),
            ],
          })
        : resultType === 'ENTITIES'
        ? aSearchResultPage({
            objects: [
              aSearchResult({
                object: anEntityInterface(),
              }),
            ],
          })
        : aSearchResultPage();

    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        dslSearchResults: results,
      })
    );
  }),
];
